export default __webpack_public_path__ + "9ba7233345056c919454146973e10ee2.woff";